import React from "react";
import { BsDot } from "react-icons/bs";
import { useSelector } from "react-redux";
import DashboardUtils from "../../../utils/DashboardUtils";

const DashboardNavLink = (props) => {
  const { item } = props;

  const userRole = useSelector(({ auth }) => auth.user.role);
  if (!DashboardUtils.hasPermission(item.auth, userRole)) {
    return null;
  }

  return (
    <a
      href={item.url}
      className="nav-link cu-bg-blue-dark-hover text-white"
      target={item.target ? item.target : "_blank"}
    >
      <BsDot />
      {/* <Icon className="mr-2 align-middle cu-text-md">{item.icon}</Icon>{" "} */}
      {item.title}
    </a>
  );
};

export default DashboardNavLink;
